<template>
  <BasicText
    size="body-m"
    color="secondary-900"
    class="habilitations__top"
  >
    Veuillez sélectionner une entité juridique et renseigner un SIRET, SIREN ou une raison sociale, ou bien sélectionner
    un utilisateur et renseigner un email, un nom ou un prénom.
  </BasicText>
  <HabilitationsAdmin
    v-if="token"
    type="administrateur"
    :auto-run="autoRun"
    :jwt-token="token"
    context-hidden
    v-bind="props.navigateToLocation"
    @query-changed="onQueryChanged"
  />
  <HabilitationsAdd />
</template>

<script setup lang="ts">
  import { onBeforeMount, onBeforeUnmount, ref } from 'vue'
  import { storeToRefs } from 'pinia'
  import HabilitationsAdmin from './HabilitationsAdmin.vue'
  import { useHabilitationsAdminViewStore } from './useHabilitationsAdminViewStore.ts'
  import { type QueryChangedEventArg } from './HabilitationsAdmin.type'
  import HabilitationsAdd from '@/features/interface/profil-utilisateur/sections/admin/HabilitationsAdd.vue'
  import { navigateTo, type NavigateToAdministration, type WithNavigateToLocation } from '@/router/navigateTo'

  const props = defineProps<WithNavigateToLocation<NavigateToAdministration>>()

  const authStore = useHabilitationsAdminViewStore()
  const autoRun = ref(false)

  const { token } = storeToRefs(authStore)

  const onQueryChanged = (isReady: boolean, query: QueryChangedEventArg) => {
    const estModifié =
      props.navigateToLocation.mode !== (query.mode ?? 'entite') ||
      (isReady &&
        (props.navigateToLocation.mode === 'habilitations' ||
          props.navigateToLocation.identifiant !== query.identifiant))

    if (estModifié)
      navigateTo({
        to: 'utilisateur',
        module: 'administration',
        mode: query.mode ?? 'entite',
        identifiant: query.identifiant as string,
      } as NavigateToAdministration)
  }

  onBeforeMount(async () => {
    autoRun.value = true
    await authStore.start()
  })

  onBeforeUnmount(() => {
    authStore.stop()
  })
</script>
<style lang="less">
  .habilitations__top {
    margin: 10px;
  }
</style>
